export const TECHNIQUES_STATUS_OPTIONS = [
  { value: 'open', label: 'Neu', color: 'warning' },
  { value: 'in_coordination', label: 'In Abstimmung', color: 'info' },
  { value: 'in_progress', label: 'In Bearbeitung', color: 'primary' },
  { value: 'not_pursued', label: 'Wird nicht weiter verfolgt', color: 'default' },
  { value: 'introduced', label: 'Wird eingeführt', color: 'success' },
];

export function getInitialTechniquesFormState(contactUserId = '') {
  return {
    title: '',
    description: '',
    contactUserId: contactUserId ? String(contactUserId) : '',
  };
}

export function buildTechniquesSubmitPayload(formState) {
  return {
    topicKey: 'techniques_working_methods',
    title: String(formState?.title || '').trim(),
    description: String(formState?.description || '').trim(),
    payload: {
      contactUserId: Number(formState?.contactUserId || 0) || null,
    },
  };
}

export function buildTechniquesEditFormState(entry) {
  return {
    title: entry?.title || '',
    description: entry?.description || '',
    contactUserId: entry?.payload?.contactUserId ? String(entry.payload.contactUserId) : '',
  };
}

export function formatTechniquesStatus(value) {
  return TECHNIQUES_STATUS_OPTIONS.find((option) => option.value === value)
    || TECHNIQUES_STATUS_OPTIONS[0];
}

export function getTechniquesStatusStats(entries) {
  return entries.reduce((stats, entry) => {
    const status = formatTechniquesStatus(entry?.status).value;
    stats[status] = (stats[status] || 0) + 1;
    return stats;
  }, Object.fromEntries(TECHNIQUES_STATUS_OPTIONS.map((option) => [option.value, 0])));
}

export function matchesTechniquesStatusFilter(entry, statusFilter) {
  return statusFilter === 'all' || formatTechniquesStatus(entry?.status).value === statusFilter;
}
